import { gql } from 'apollo-angular';

import { ADDRESS_FRAGMENT } from 'graphql/fragments/address';

export const CUSTOMER_WITHOUT_CONDITIONS_FRAGMENT = gql`
  fragment CustomerWithoutConditionsFragment on Customer {
    name
    id
    addresses {
      ...AddressFragment
    }
  }
  ${ADDRESS_FRAGMENT}`;
